// extracted by mini-css-extract-plugin
module.exports = {"container":"PreviewCard_container__2cVBe","headerWrapper":"PreviewCard_headerWrapper__CUJf8","label":"PreviewCard_label__1omM3"};